export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9036.d6ab4e6b.jpg";